import React from 'react';
import { OrderStatus } from '@api/Orders/Order';
import Counter from '@components/Utilities/Counter';
import useCounter from '@hooks/useCounter';

interface OrderElapsedTimeProps {
    /** Desde cuándo corre el reloj (la fecha del pedido). */
    start?: Date;
    status: OrderStatus;
    /** Lo que tardó, en segundos: `completeOrder` lo escribe al cerrar. */
    duration?: number;
}

/**
 * El "Tiempo" de un pedido: corre en vivo mientras no esté completado y, ya
 * cerrado, muestra lo que tardó (`duration`). Lo comparten el detalle de
 * `/orders` y `ModalViewOrder`, que antes llevaban cada uno su copia.
 *
 * El reloj vive AQUÍ y no en la pantalla: `useCounter` hace un `setState` por
 * segundo, y así solo se vuelve a pintar el contador.
 */
const OrderElapsedTime: React.FunctionComponent<OrderElapsedTimeProps> = ({ start, status, duration }) => {
    const [days, hours, minutes, seconds] = useCounter(start);
    return status !== OrderStatus.Completed ? (
        <Counter days={days} hours={hours} minutes={minutes} seconds={seconds} />
    ) : (
        <Counter timeInSeconds={duration} />
    );
};

export default OrderElapsedTime;
